import { render, staticRenderFns } from "./stripe-element.vue?vue&type=template&id=3ec21776&scoped=true&"
import script from "./stripe-element.vue?vue&type=script&lang=js&"
export * from "./stripe-element.vue?vue&type=script&lang=js&"
import style0 from "./stripe-element.vue?vue&type=style&index=0&id=3ec21776&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ec21776",
  null
  
)

export default component.exports